// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"15103b75","498":"030aedd5","513":"15f4553b"}[chunkId] + ".chunk.js";
};